/* The pharmacy: queue, dispensing, the counter and returns (dispensing plan §8). Tokens only. */

.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.sectionHeading {
  font: var(--t-heading);
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--space-3);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
}

.row > * {
  flex: 1 1 10rem;
  min-width: 0;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.meta {
  color: var(--graphite);
  font: var(--t-small);
}

.strong {
  font: var(--t-body-strong);
}

.numbers {
  font-variant-numeric: tabular-nums;
}

/* The sale total and the change are what the customer is told: large, tabular. */
.total {
  font: var(--t-title);
  font-variant-numeric: tabular-nums;
}

.change {
  font: var(--t-title);
  font-variant-numeric: tabular-nums;
}

.fieldset {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.fieldset > legend {
  float: left;
  width: 100%;
  padding: 0;
}

/* The counter: the search and cart on the left, the payment on the right. */
.counter {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(16rem, 22rem);
  gap: var(--space-5);
  align-items: start;
}

@media (width < 60rem) {
  .counter {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* A heading with a quiet action beside it, on one line. */
.headingRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2) var(--space-4);
}

.queueHeader {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-1) var(--space-3);
}

.queue {
  display: flex;
  flex-direction: column;
  border-top: 1px solid var(--rule);
}

.queueItem {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-height: 44px;
  padding: var(--space-3) var(--space-2);
  border-bottom: 1px solid var(--rule);
  color: var(--ink);
  text-decoration: none;
}

.queueItem:hover {
  border-radius: var(--radius-control);
  background: var(--brand-tint);
}

/* The chosen item: a soft grey rounded fill, like the reference; the text stays in place. */
.queueItem[aria-current='page'] {
  border-radius: var(--radius-control);
  background: var(--brand-tint-strong);
  font-weight: 500;
}

.queueItem:focus-visible {
  outline: var(--focus-ring);
  outline-offset: -2px;
}

.queueLine {
  display: flex;
  justify-content: space-between;
  gap: var(--space-3);
}

.pickerRow {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0 var(--space-4);
  width: 100%;
}

.pickerName {
  font: var(--t-body-strong);
  overflow-wrap: anywhere;
}

.pickerMeta {
  grid-column: 1 / -1;
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  color: var(--graphite);
  font: var(--t-small);
}

/* One medicine: often a fieldset, so the browser's frame is removed. */
.line {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: 0;
  margin: 0;
  padding: var(--space-4) 0;
  border: 0;
  border-bottom: 1px solid var(--rule);
}

.line > legend {
  float: left;
  width: 100%;
  padding: 0;
}

.lineHeading {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: var(--space-3);
  font: var(--t-body-strong);
}

.quantity {
  max-width: 10rem;
}

.facts {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: var(--space-1) var(--space-4);
  margin: 0;
}

.facts dt {
  color: var(--graphite);
}

.facts dd {
  margin: 0;
}

.receiptPreview {
  max-width: 22rem;
}
